import * as d3 from 'd3';

import Base from '@/story/graphic/base';

class Scenarios extends Base {

	render() {
		this.init();
	}

	setData(data) {
		this.data = d3.filter(data, d => { 
			return !isNaN(Number(this.x(d))) && Number(this.x(d)) !== 0
		});
	}

	setup(data, {
		value = d => d, // convience alias for x
		label, // convenience alias for xLabel
		type = d3.scaleLinear, // convenience alias for xType
		domain, // convenience alias for xDomain
		x = value, // given d in data, returns the quantitative x value
		title = null, // given d in data, returns the title
		radius = 3, // (fixed) radius of the circles
		className = d => 'knd',
		padding = 1.5, // (fixed) padding between the circles
		xType = type, // type of x-scale, e.g. d3.scaleLinear
		xLabel = label, // a label for the x-axis
		xDomain = domain, // [xmin, xmax]
		xRange = null, //
		el = null,
		color = '#F9BDBE',
		rType = d3.scaleLinear,
		rRange,
		rDomain,
		rValue = d => d
	}) {
			this.data = d3.filter(data, d => { 
				return !isNaN(Number(x(d))) && Number(x(d)) !== 0
			});

			this.value = value;
			this.label = label;
			this.type = type;
			this.domain = domain;
			this.x = x;
			this.title = title;
			this.radius = radius;
			this.padding = padding;
			this.xType = xType;
			this.xLabel = xLabel;
			this.xDomain = xDomain;
			this.xRange = xRange;
			this.rType = rType;
			this.rDomain = rDomain;
			this.rRange = rRange;
			this.rValue = rValue;

			this.className = className;
			this.color = color;
	}

	setScene(scene, className) {
		this.scene = scene;

		this.g.classed('scene-beeswarm', false);
		this.g.classed('scene-clustered', false);

		this.g.classed(className, true);
	}

	setupBeeswarm() {

		this.setScene('BEESWARM', 'scene-beeswarm');

		this.X = d3.map(this.data, this.x).map(x => x == null ? NaN : +x);
		this.xDomain = d3.extent(this.X);


		this.R = d3.map(this.data, this.rValue).map(x => x == null ? NaN : +x);
		this.rDomain = d3.extent(this.R);

		this.xScale = d3.scaleLinear();

		this.radius = 5;
		
		this.rScale = this.rType(this.rDomain, this.rRange).nice();

		const t = this.svg.transition()
				.duration(500);

		this.xRange = [this.margin.left, this.width() - this.margin.right];
		this.xScale.range(this.xRange);

		let totalTicks = this.width() < 550 ? 3 : 5;

		this.xScale.domain([0, this.xDomain[1]]).nice();
		this.xAxis = d3.axisBottom(this.xScale)
			.tickSizeInner(this.height())
			.ticks(totalTicks)
			.tickFormat(x => `€${x}`)

		this.gAxis
			.attr("transform", `translate${this.margin.top},${0 - this.margin.bottom})`)

		this.gAxis
			.call(this.xAxis)
			.call(g => g.selectAll)

		// this.simulation = d3.forceSimulation(this.data)
		// 		.force("x", d3.forceX(d => this.xScale(this.x(d))))
		// 		.force("y", d3.forceY(this.height() / 2))
		// 		.force("collide", d3.forceCollide(d => this.rScale(this.rValue(d)) + 1))
		// 		.stop();

		this.data = this.dodge(this.data);

		// for (let i = 0; i < this.data.length; ++i) {
		// 	this.simulation.tick();
		// }	

		this.renderBeeswarm();
	}

	renderBeeswarm() {
		const node = this.g
			.selectAll(".knd-circle")
			.data(this.data, d => { return d.gemeente_naam })
			.join(
				enter => this.enterBeeswarm(enter),
				update => this.updateBeeswarm(update),
				exit => this.exitBeeswarm(exit)
			);
	}

	enterBeeswarm(enter) {
		enter.append('g')
		.attr('class', this.className)
		.attr('transform', d => `translate(${d.x}, ${this.height() - this.margin.bottom - 1 - d.y})`)
		.call( g => 
			g.append("circle")
			.attr("r", 0)
			.transition()
			.duration(750)
			.attr("r", d => d.r)
			.style("fill", '#F9BDBE')			
		)
		.call( g => 
			g.append("text")
			.attr('class', 'beeswarm-text')
			.attr("dy", "-1em")
		)	
		.call(g => 
			g.append('title')
      .text(d => d.gemeente_naam + ' ' + this.x(d))
		)

		// this.simulation.on("tick", () => {
		// 	enter.selectAll('.knd-circle').attr('transform', d => { return `translate(${d.x}, ${d.y})` })
		// });
	}

	updateBeeswarm(update) {
		update
		.call(g => g.select('circle')
			.transition()
			.duration(750)
			.attr("r", d => this.rScale(this.rValue(d)))
		)
		.call(g => g.select('text')
			.text('')
			.style('font-size', '12px')
		)
		.attr('class', this.className)
		.transition().duration(1000)
		.attr('transform', d => `translate(${d.x}, ${this.height() - this.margin.bottom - 1 - d.y})`)

	}

	exitBeeswarm(exit) {
		exit
			.call(g =>
				g.transition().duration(1000)
					.attr('transform', (d,i) => `translate(${ this.width() + 50 },${ d.y })`)
					.style('opacity', 0)
					.remove()
			)
	}

	renderClusteredCircles(data) {
		this.setScene('CLUSTERED', 'scene-clustered');

		let xDomain = d3.extent(data, d => d.value);

		this.gAxis.html('');

		this.rScale = d3.scaleSqrt()
			.domain(xDomain)
			.range([0, 100])

			this.simulation = d3.forceSimulation(data)
				.force("center", d3.forceCenter(this.width() / 2, this.height() / 2))
				.force("x", d3.forceX(this.width() / 2).strength(0.01))
				.force("y", d3.forceY(this.height() / 2).strength(0.01))
				.force("collide",d3.forceCollide( (d) => {
					return this.rScale(d.value)  + 1 }).iterations(4) 
				)
				.stop();

		for (var i = 0; i < 120; ++i) this.simulation.tick();

		const node = this.g
			.selectAll(".knd-circle")
			.data(data, d => { return d.label})
			.join(
				enter => this.enterClusteredCircles(enter),
				update => this.updateClusteredCircles(update),
				exit => this.exitCircles(exit)
			)
	}

	enterClusteredCircles(enter) {
		enter.append('g')
		.attr('class', d => 'knd-circle ' + 'knd-' + d.label)
		.attr('transform', d => `translate(${this.width()/2}, ${this.height()/2})`)
		.call( g => 
			g.append("circle")
			.transition()
			.delay((d, i) => Math.random() * 500)
			.duration(750)
			.attr("r", d => this.rScale(d.value))
		)
		.call( g => 
			g.append("text")
			.attr('class', 'circle-text')
			.attr("dy", ".3em")
			.text((d) => { return d.label })
			.style("font-size", (d, i, nodes) => { 
				let computed = (2 * this.rScale(d.value) - 15) / nodes[i].getComputedTextLength() * 10;
				let maxSize = Math.min(computed, 40);
				return maxSize + "px"; 
			})
		)
		.transition()
			.duration(2000)
			.attr('transform', d => `translate(${d.x}, ${d.y})`)

	}

	updateClusteredCircles(update) {
		update
			.call( g => 
				g.select("circle")
				.attr("r", d => this.rScale(d.value))
			)
			.transition().duration(1000)
			.attr('transform', d => `translate(${d.x}, ${d.y})`)
	}

	exitCircles(exit) {
		exit
			.call(g =>
				g.transition().duration(1000)
					.style('opacity', 0)
					.remove()
			)
	}

	disableSelect() {
		this.g.selectAll('.knd-circle')
			.classed('inactive', true)
	}

	enableMouseClick(cb, cbTooltip) {
		this.g.selectAll('.knd-circle circle')
			.classed('click', true)
			.on('click', cb)
	}

	enableMouseOver(cb, cbOut) {
		this.g.selectAll('.knd-circle circle')
			.on('mouseover', cb)
			.on('mouseout', cbOut)
	}

	highLightGemeente(label) {
		this.g.classed('highlight-active', true)

		this.g.select(label)
			.raise()
			.classed('active', true)
			.call(
				g => g.select('text')
				.text(d => d.gemeente_naam)
			)
	}

	highLight(label) {
		this.g.selectAll(label)
			.raise()
			.classed('active', true)
	}

	resetHighlights() {
		this.g.classed('highlight-active', false)
		this.g.selectAll('.active')
			.classed('active', false)
	}


	hideCircles(label) {
		this.g.selectAll(".knd-circle:not(" + label + ")")
			.classed('inactive', true);
	}

	dodge (data) {
		let padding = 1;
		const circles = data.map(d => ({x: this.xScale(this.x(d)) -5, r: this.rScale(this.rValue(d)), ...d})).sort((a, b) => b.r - a.r);
		const epsilon = 1e-3;
		let head = null, tail = null, queue = null;

		// Returns true if circle ⟨x,y⟩ intersects with any circle in the queue.
		function intersects(x, y, r) {
			let a = head;
			while (a) {
				const radius2 = (a.r + r + padding) ** 2;
				if (radius2 - epsilon > (a.x - x) ** 2 + (a.y - y) ** 2) {
					return true;
				}
				a = a.next;
			}
			return false;
		}

		// Place each circle sequentially.
		for (const b of circles) {
			// Choose the minimum non-intersecting tangent.
			if (intersects(b.x, b.y = b.r, b.r)) {
				let a = head;
				b.y = Infinity;
				do {
					let y = a.y + Math.sqrt((a.r + b.r + padding) ** 2 - (a.x - b.x) ** 2);
					if (y < b.y && !intersects(b.x, y, b.r)) b.y = y;

					a = a.next;
				} while (a);
			}

			// Add b to the queue.
			b.next = null;
			if (head === null) {
				head = tail = b;
				queue = head;
			} else tail = tail.next = b;
		}

		return circles;
	}
}

export default Scenarios;